import { useRef, useEffect } from 'react';

export const useDragScroll = () => {
    const ref = useRef<HTMLDivElement | null>(null);
    const isDown = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const canScroll = useRef(false);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (!isDown.current || !ref.current || !canScroll.current) return;
            const x = e.pageX - ref.current.offsetLeft;
            const walk = x - startX.current;
            ref.current.scrollLeft = scrollLeft.current - walk;
        };

        const handleMouseUp = () => {
            isDown.current = false;
            ref.current?.classList.remove('cursor-grabbing');
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    const onMouseDown = (e: React.MouseEvent) => {
        if (!ref.current) return;

        if (ref.current.scrollWidth <= ref.current.clientWidth) return;

        canScroll.current = true;
        isDown.current = true;
        ref.current.classList.add('cursor-grabbing');
        startX.current = e.pageX - ref.current.offsetLeft;
        scrollLeft.current = ref.current.scrollLeft;
    };

    return {
        ref,
        onMouseDown,
    };
};
